import { SvgIconProps } from '@traba/types'

export default function ThumbsUpFilled({
  color = '#7A8A99',
  size = 24,
}: SvgIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00706 2.1943L3.64049 5.64522C3.54767 5.87963 3.5 6.12947 3.5 6.38158V8.5C3.5 9.60457 4.39543 10.5 5.5 10.5H8.81891C9.68198 10.5 10.4477 9.94635 10.7182 9.12675L10.9093 8.54754C11.3234 7.29261 10.3888 6 9.06733 6C7.99607 6 7.12764 5.13157 7.12764 4.06031V2.59889C7.12764 1.99199 6.63565 1.5 6.02875 1.5C5.57803 1.5 5.17301 1.77523 5.00706 2.1943Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
      />
      <path
        d="M2 6.75V9.75"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
